import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=c536e622&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c536e622",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c536e622')) {
      api.createRecord('c536e622', component.options)
    } else {
      api.reload('c536e622', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=c536e622&scoped=true&", function () {
      api.rerender('c536e622', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UEZMrfcYmVYA/JS/comp/SearchFilterTokens.vue"
export default component.exports